import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type DeleteProductCategoryMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteCoreProductCategoryInput;
}>;

export type DeleteProductCategoryMutationResult = { __typename?: 'Mutation' } & {
  deleteCoreProductCategory: { __typename?: 'DeleteCoreProductCategoryPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const DeleteProductCategoryDocument = /*#__PURE__*/ gql`
  mutation deleteProductCategory($input: DeleteCoreProductCategoryInput!) {
    deleteCoreProductCategory(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useDeleteProductCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductCategoryMutation, { data, loading, error }] = useDeleteProductCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteProductCategoryMutationResult, DeleteProductCategoryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<DeleteProductCategoryMutationResult, DeleteProductCategoryMutationVariables>(
    DeleteProductCategoryDocument,
    options
  );
}
export type DeleteProductCategoryMutationHookResult = ReturnType<typeof useDeleteProductCategoryMutation>;
